import { useMemo } from 'react'
import { AccountInfo } from '@azure/msal-browser'
import { useMsal } from '@azure/msal-react'
import { IconUserCircle } from '@tabler/icons-react'
import { List, NavLink as MantineNavLink } from '@mantine/core'
import classes from './user-menu.module.css'

export interface UserMenuProps {
  closeMobileMenu: VoidFunction
  logoutComponent?: React.ReactNode
}

export const UserMenu = ({ closeMobileMenu, logoutComponent }: UserMenuProps) => {
  const { instance } = useMsal()
  const account: AccountInfo | null = useMemo(() => instance.getActiveAccount(), [instance])

  return (
    <List
      spacing='xs'
      listStyleType='none'
      w='100%'
      classNames={{
        root: classes.list,
        itemWrapper: classes.itemWrapper,
        itemLabel: classes.itemLabel,
      }}
      aria-label='User menu'
    >
      <List.Item>
        <MantineNavLink
          label={account?.name}
          leftSection={<IconUserCircle />}
          classNames={{
            root: classes.navLink,
            section: classes.iconSection,
          }}
          onClick={closeMobileMenu}
        />
      </List.Item>
      {logoutComponent && <List.Item>{logoutComponent}</List.Item>}
    </List>
  )
}
